jQuery(function ($) {
  const regExpAlphabet = /[a-zA-Z]/g;

  if (
    navigator.platform.indexOf('iPhone') >= 0 ||
    navigator.platform.indexOf('iPad') >= 0 ||
    navigator.platform.indexOf('iPod') >= 0
  ) {
    // Update directions link for iOS.
    $('.locations__directions-link').each(function () {
      const href = $(this).attr('href');
      $(this).attr('href', href.replace('https://', 'maps://'));
    });
  }

  // Removes uneeded comma from office hours when there are no comments.
  $('.office-hours__item-comments').each(function () {
    if (!regExpAlphabet.test($(this).text())) {
      $(this).hide();
    }
  });
});
